import { reject } from 'lodash';
import { activeRequests, allowedRequestUrl } from './api.state';
import { AxiosRequestController } from '@/modules/core/app/models/AxiosRequestController';

export function addRequest(requestController: AxiosRequestController): void {
  activeRequests.value.push(requestController);
}

export function removeRequest(path: string): void {
  activeRequests.value = reject(
    activeRequests.value,
    (controller: AxiosRequestController) => controller.url === path
  );
}

export function setAllowedRequestUrl(path: string | undefined): void {
  allowedRequestUrl.value = path;
}

// Used for vitest
export function clearState(): void {
  activeRequests.value = [];
  allowedRequestUrl.value = undefined;
}
